import { checkActions } from '@redux/slices/checks';
import { inspectionActions } from '@redux/slices/inspection';
import { getAppDispatch } from '@utilities/dispatch.util';

const inspectionTypeManipulationJson = ({ data }) => {
  const { items = [] } = data;
  const checkType = items?.filter((x) => x?.module === 'AssetCheck') || [];

  const inspectionType =
    items?.filter((x) => x?.module === 'Inspection' || x?.module === 'Incident') || [];

  const inspectionTypesMap = inspectionType?.reduce((acc, curr) => {
    acc[curr.key] = {
      key: curr.key,
      value: curr.value,
      frequencyId: curr?.frequencyId
    };
    return acc;
  }, {});

  const checkTypesMap = checkType?.reduce((acc, curr) => {
    acc[curr.key] = {
      key: curr.key,
      value: curr.value,
      frequencyId: curr?.frequencyId
    };
    return acc;
  }, {});

  return {
    checkType,
    inspectionType,
    inspectionTypesMap,
    checkTypesMap
  };
};

const inspectionTypesAndCheckTypesDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    inspectionActions.setInspectionTypes({
      inspectionTypes: data?.inspectionType,
      inspectionTypesMap: data?.inspectionTypesMap
    })
  );
  dispatch?.(
    checkActions.setCheckTypes({
      checksTypes: data?.checkType,
      checkTypesMap: data?.checkTypesMap
    })
  );
};

export { inspectionTypeManipulationJson, inspectionTypesAndCheckTypesDispatcher };
